import React from 'react';
import clsx from 'clsx';

import Button from '../Button';
import { ButtonActionType } from '../MindMap/components/const';
import type { ButtonOptions } from '../MindMap/components/types';

type ButtonGroupProps = {
  buttons: ButtonOptions[];
  orientation?: 'horizontal' | 'vertical';
  className?: string;
  buttonClassName?: string;
  dividerClassName?: string;
  onClick: (action: ButtonActionType) => void;
};

export const ButtonGroup: React.FC<ButtonGroupProps> = ({
  buttons,
  className,
  onClick,
  buttonClassName = 'p-4',
  orientation = 'horizontal',
  dividerClassName = 'bg-lightGray',
}) => {
  return (
    <div
      className={clsx(
        'inline-flex',
        orientation === 'vertical' ? 'flex-col' : 'flex-row',
        className
      )}
    >
      {buttons.map((button, index) => (
        <React.Fragment key={index}>
          <div className="relative">
            <Button
              {...button}
              size="empty"
              type="empty"
              onClick={() => onClick && onClick(button.action)}
              className={clsx(
                buttonClassName,
                'bg-middleGray border-0 hover:bg-secondary'
              )}
              roundedLeft={index === 0}
              roundedRight={index === buttons.length - 1}
              orientation={orientation}
              icon={
                button.action === ButtonActionType.ZOOM_OUT ? (
                  <div className="rotate-90">{button.icon}</div>
                ) : (
                  button.icon
                )
              }
            />

            {index < buttons.length - 1 && (
              <div
                className={clsx(
                  orientation === 'horizontal'
                    ? 'w-[0.1rem] h-[70%] top-1/2 translate-y-[-50%] right-0'
                    : 'h-[0.1rem] w-[70%] left-1/2 translate-x-[-50%] bottom-0',
                  dividerClassName,
                  'absolute'
                )}
              />
            )}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};
